import { render, staticRenderFns } from "./VueFormSelect.vue?vue&type=template&id=46f53ff4&"
import script from "./VueFormSelect.vue?vue&type=script&lang=js&"
export * from "./VueFormSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports